module.exports = __webpack_public_path__ + "img/shenhe.ec731f55.png";